import { RightOutlined } from '@ant-design/icons';

import { Col, Divider, Row, Typography } from 'antd';
import React from 'react';
import { useHistory } from 'react-router';

interface Props {
  id: number;
  name: string;
  role: string;
  updatedAt: string;
  status: string;
}

const MemberRequest = ({ id, name, role, updatedAt, status }: Props) => {
  const history = useHistory();
  return (
    <>
      <div style={{ padding: '2rem' }}>
        <Typography.Title level={5}>{name}</Typography.Title>
        <Row>
          <Col flex={1}>
            <Typography.Text>{updatedAt}</Typography.Text>
          </Col>

          <Col flex={0} className="view-more">
            <Typography.Text>{role}</Typography.Text>
            <RightOutlined
              style={{ marginLeft: '1rem' }}
              onClick={() => {
                history.push({
                  pathname: `/admin/busk/${
                    role == '물류센터' ? 'logistic' : 'sellers'
                  }/${id}`,
                  state: {
                    state: status
                  }
                });
              }}
            />
          </Col>
        </Row>
      </div>
    </>
  );
};

export default MemberRequest;
